import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {OutletSearchModel} from "../outlet-search.model";
import {OutletSearchPageComponent} from "../outlet-search-page/outlet-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";


@Component({
    selector: "wbo-outlet-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(OutletSearchModel),
        registerSearchControl(OutletMultiSelectSearchControlComponent)
    ]
})
export class OutletMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<OutletSearchModel> {
    constructor(model: OutletSearchModel, injector: Injector) {
        super(model, injector, "outletId", "name");
        this.extendedSearchComponent = OutletSearchPageComponent;
    }
}
